// jQuery - Add to window to make it available globally to scripts outside bundle
import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

// jQuery migrate
import 'jquery-migrate';

// Mute jQuery migrate warnings since we are using it to support older jQuery plugins and not for migration purposes
$.migrateMute = true;
$.migrateTrace = false;

// jQuery UI
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/menu';
import 'jquery-ui/ui/widgets/mouse';
import 'jquery-ui/ui/widgets/progressbar';
import 'jquery-ui/ui/widgets/tooltip';
import 'jquery-ui/themes/base/all.css';

// jQuery mousewheel
import 'jquery-mousewheel';

// JS cookie
import cookies from 'js-cookie';
window.Cookies = cookies;

// Bootstrap
import 'bootstrap/dist/css/bootstrap.css';
window.bootstrap = bootstrap;

// Bootstrap-select
import 'bootstrap-select';
import 'bootstrap-select/dist/css/bootstrap-select.css';

// Form related
import 'jquery-validation';
import './js/jquery.validate.unobtrusive.js';
import './js/jquery-ajax-unobtrusive.min.js';
import 'multiselect';
import 'multiselect/css/multi-select.css';

// JSZip
import jszip from 'jszip';
window.JSZip = jszip;

// PDFmake
import pdfMake from 'pdfmake';
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.addVirtualFileSystem(pdfFonts);

// DataTables
import 'datatables.net';
import 'datatables.net-bs4';
import 'datatables.net-buttons';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-select';
import 'datatables.net-select-bs4';
import 'datatables.net-responsive';
import 'datatables.net-responsive-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';
import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.css';

// Idle timeout
import idleTimeoutPlus from './js/terso-idleTimeout.js';
window.TersoTimeout = idleTimeoutPlus;
import './css/terso-idleTimeout.css'

// Storage
import storages from 'js-storage';
window.Storages = storages

// Noty
import noty from 'noty';
window.Noty = noty;
import 'noty/lib/noty.css';

// Malihu custom scrollbar plugin
import 'malihu-custom-scrollbar-plugin';
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css';

// Tempus Dominus
import * as tempusDominus from '@eonasdan/tempus-dominus';
window.tempusDominus = tempusDominus;
import '@eonasdan/tempus-dominus/dist/css/tempus-dominus.css';

// Unify
import './js/hs.core.js';
import './js/hs.datepicker-1.0.js';
import './js/hs.dropdown.js';
import './js/hs.focus-state.js';
import './js/hs.go-to.js';
import './js/hs.hamburgers.js';
import './js/hs.modal-window.js';
import './js/hs.multi-select.js';
import './js/hs.scrollbar.js';
import './js/hs.side-nav.js';
import './js/hs.tabs.js';
import './css/unify-admin.css';

// Misc CSS
import 'font-awesome/css/font-awesome.css';
import './css/animate.css';
import './css/custom.css';
import 'bootstrap-icons/font/bootstrap-icons.min.css';

// Replace apply for Function.constructor to prevent CSP eval errors when jquery unobtrusive ajax
// does not have a function to pass for one of the ajax callbacks
// https://github.com/aspnet/jquery-ajax-unobtrusive/issues/49
Function.apply = function (element, args) {
    if (args && args.length && args.length !== 0) {
        var code = args[args.length - 1];
        if (code) {
            console.log('JavaScript evaluation prevented - ' + code);
        }
    }

    return function () { return null; };
};